import React, { useState } from "react";
import Swal from "sweetalert2";
import { submitCustomerNotification } from "../../../../api/Api";
import { getFromLocalStorage } from "../../../../utils/common-utils";
import Loader from "../../../../components/loader/loader";
import "./custNotificationsTabs.css";
// import "./custNotificationTabs.css";

export default function CustNotificationTabs({
  productId,
  setActiveTab,
  serviceId,
  getAllData,
  setAddProductModal,
}) {
  const [notificationData, setNotificationData] = useState({
    preRenewal: "no",
    preRenewalDays: "",
    renNotify: "yes",
    renNotifyFreq: "OnEveryRenewal",
    cancelNotify: "yes",
    lowBalNotify: "no",
    subNotify: "yes",
  });
  const [isLoading, setIsLoading] = React.useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setNotificationData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const payload = {
        userId: getFromLocalStorage("userData")?.id,
        serviceId: serviceId,
        id: productId,
        preRenewal: notificationData.preRenewal,
        preRenewalDays:
          notificationData.preRenewal === "yes"
            ? notificationData.preRenewalDays
            : null,
        renNotify: notificationData.renNotify,
        renNotifyFreq: notificationData.renNotifyFreq,
        cancelNotify: notificationData.cancelNotify,
        lowBalNotify: notificationData.lowBalNotify,
        subNotify: notificationData.subNotify,
      };

      const response = await submitCustomerNotification(payload);

      if (response?.statusDescription?.status === 200) {
        Swal.fire({
          icon: "success",
          text:
            response?.statusDescription?.description ||
            "Customer notification settings saved successfully!",
        }).then(() => {
          // Close the modal after showing success message
          setAddProductModal(false);
          getAllData();
        });
        // This is the last tab
        setActiveTab("productDetails");
      } else {
        Swal.fire({
          icon: "error",
          text:
            response?.statusDescription?.description ||
            "Failed to save customer notification settings",
        });
      }
    } catch (error) {
      console.error("Error submitting customer notification settings:", error);
      Swal.fire({
        icon: "error",
        text: "Failed to save customer notification settings",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      {/* <div className="tab-content"> */}
      <div className="tab-pane active">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>
                Pre-renewal Reminder<span className="text-danger">*</span>
              </label>
              <div className="d-flex align-items-center radio_div_span">
                {/* <div className="form-check mr-3"> */}
                <input
                  type="radio"
                  className="form-check-input"
                  name="preRenewal"
                  value="yes"
                  checked={notificationData.preRenewal === "yes"}
                  onChange={handleChange}
                />
                {/* <label className="form-check-label">Yes</label> */}
                <span className="ml-1">Yes</span>
                {/* </div> */}
                {/* <div className="form-check"> */}
                <input
                  type="radio"
                  // className="form-check-input"
                  name="preRenewal"
                  value="no"
                  checked={notificationData.preRenewal === "no"}
                  onChange={handleChange}
                  className="ml-3"
                />
                {/* <label className="form-check-label">No</label> */}
                <span className="ml-1">No</span>
                {/* </div> */}
              </div>
            </div>
          </div>

          {notificationData.preRenewal === "yes" && (
            <div className="col-md-6">
              <div className="form-group">
                <label>
                  Pre-renewal Reminder Days
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  name="preRenewalDays"
                  value={notificationData.preRenewalDays}
                  onChange={handleChange}
                >
                  <option value="">Select Days</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                </select>

              </div>
            </div>
          )}
        </div>

        <div className="row mt-3">
          <div className="col-md-6">
            <div className="form-group">
              <label>
                Notify Customer On Renewal<span className="text-danger">*</span>
              </label>
              <div className="d-flex align-items-center radio_div_span">
                {/* <div className="form-check mr-3"> */}
                <input
                  type="radio"
                  className="form-check-input"
                  name="renNotify"
                  value="yes"
                  checked={notificationData.renNotify === "yes"}
                  onChange={handleChange}
                />
                {/* <label className="form-check-label">Yes</label> */}
                <span className="ml-1">Yes</span>

                {/* </div> */}
                {/* <div className="form-check"> */}
                <input
                  type="radio"
                  // className="form-check-input"
                  name="renNotify"
                  value="no"
                  checked={notificationData.renNotify === "no"}
                  onChange={handleChange}
                  className="ml-3"

                />
                {/* <label className="form-check-label">No</label> */}
                <span className="ml-1">No</span>

                {/* </div> */}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>
                Notification Frequency in Renewal
                <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="renNotifyFreq"
                value={notificationData.renNotifyFreq}
                onChange={handleChange}
              >
                <option value="OnEveryRenewal">On Every Renewal</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
              </select>

            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-4 md_4">
            <div className="form-group">
              <label>
                Notify Customer On Subscription
                <span className="text-danger">*</span>
              </label>
              <div className="d-flex align-items-center radio_div_span">
                {/* <div className="form-check mr-3"> */}
                <input
                  type="radio"
                  className="form-check-input"
                  name="subNotify"
                  value="yes"
                  checked={notificationData.subNotify === "yes"}
                  onChange={handleChange}
                />
                {/* <label className="form-check-label">Yes</label> 
                  */}
                <span className="ml-1">Yes</span>

                {/* </div> */}
                {/* <div className="form-check"> */}
                  <input
                    type="radio"
                    // className="form-check-input"
                    name="subNotify"
                    value="no"
                    checked={notificationData.subNotify === "no"}
                    onChange={handleChange}
                    className="ml-3"

                  />
                  {/* <label className="form-check-label">No</label> */}
                  <span className="ml-1">No</span>

                {/* </div> */}
              </div>
            </div>
          </div>

          <div className="col-md-4 md_4">
            <div className="form-group">
              <label>
                Notify Customer On Low Balance
                <span className="text-danger">*</span>
              </label>
              <div className="d-flex align-items-center radio_div_span">
                {/* <div className="form-check mr-3"> */}
                  <input
                    type="radio"
                    className="form-check-input"
                    name="lowBalNotify"
                    value="yes"
                    checked={notificationData.lowBalNotify === "yes"}
                    onChange={handleChange}
                  />
                  {/* <label className="form-check-label">Yes</label> */}
                  <span className="ml-1">Yes</span>

                {/* </div> */}
                {/* <div className="form-check"> */}
                  <input
                    type="radio"
                    // className="form-check-input"
                    name="lowBalNotify"
                    value="no"
                    checked={notificationData.lowBalNotify === "no"}
                    onChange={handleChange}
                    className="ml-3"

                  />
                  {/* <label className="form-check-label">No</label> */}
                  <span className="ml-1">No</span>

                {/* </div> */}
              </div>
            </div>
          </div>

          <div className="col-md-4 md_4">
            <div className="form-group">
              <label>
                Notify Customer On Cancellation
                <span className="text-danger">*</span>
              </label>
              <div className="d-flex align-items-center radio_div_span">
                {/* <div className="form-check mr-3"> */}
                  <input
                    type="radio"
                    className="form-check-input"
                    name="cancelNotify"
                    value="yes"
                    checked={notificationData.cancelNotify === "yes"}
                    onChange={handleChange}
                  />
                  {/* <label className="form-check-label">Yes</label> */}
                  <span className="ml-1">Yes</span>

                {/* </div> */}
                {/* <div className="form-check"> */}
                  <input
                    type="radio"
                    // className="form-check-input"
                    name="cancelNotify"
                    value="no"
                    checked={notificationData.cancelNotify === "no"}
                    onChange={handleChange}
                    className="ml-3"

                  />
                  {/* <label className="form-check-label">No</label> */}
                  <span className="ml-1">No</span>

                {/* </div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-12 d-flex justify-content-between buttons_divs">
            <button
              type="button"
              className="btn btn-secondary mr-2"
              onClick={() => setActiveTab("partnerNotification")}
            >
              Previous
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}
